// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__26Hmh","resendInfoText":"OnGoingPaymentBox_resendInfoText__37cD3"};